export const environment = {
  production: true
};



// WEBPACK FOOTER //
// C:/apache/localhost/www/Angular/task2/src/environments/environment.ts